<script setup lang="ts">
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import WorkTypeRadio from "@/components/atoms/orders/WorkTypeRadio.vue";
import { CustomFormOption } from "@/types/form/FormOption";
import { PropType } from "vue";

type RadioButtonOption = CustomFormOption<number>;

defineProps({
  value: {
    type: Number as PropType<number | null>,
    required: false
  },
  options: {
    type: Array as PropType<RadioButtonOption[]>,
    required: true,
    default: () => []
  },
  name: {
    type: String,
    required: true,
    default: ""
  },
  validationState: {
    type: Object,
    required: false
  }
});

const emit = defineEmits(["update:value"]);

const onChange = (v: string) => {
  emit("update:value", v);
};
</script>

<template>
  <div>
    <div class="work-type-radio-group">
      <div
        v-for="option in options"
        :key="String(option.value)"
        class="work-type-radio-group-item"
      >
        <WorkTypeRadio
          :name="name"
          v-model:value="option.value"
          :id="`${name}-option-${option.value}`"
          :text="option.text"
          :checked="value === option.value"
          @change="onChange"
        />
      </div>
    </div>
    <FormInvalidFeedback :validation-state="validationState" :state="false" />
  </div>
</template>

<style lang="scss" scoped>
.work-type-radio-group {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 8px;
  margin-right: -8px;
  margin-left: -8px;

  & .work-type-radio-group-item {
    flex-grow: 1;
    margin: 0 8px;
  }
}
</style>
